import React, { useEffect } from "react";
import { useFormik } from "formik";
import { validationSchema } from "./initiateValidation";
import { Button, TextField } from "@mui/material";
import { MuiFileInput } from "mui-file-input";
import { useInitiateTransactionMutation } from "state/api";
import { useNavigate } from "react-router-dom";
const EditCustomer = ({ customer, carId, setLoader }) => {
  const [initiateTransaction] = useInitiateTransactionMutation();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      buyerName: customer?.customerName || "",
      buyerEmail: customer?.customerEmail || "",
      buyerContact: customer?.customerNumber || "",
      buyerAddress: customer?.customerAddress || "",
      buyerPanCardId: "",
      buyerAadharCardId: "",
      buyerAddressProofTypeOfDocument: "",
      buyerPanCardFile: null,
      buyerAadharCardFile: null,
      buyerAddressProofFile: null,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      values.carId = carId;
      const formData = new FormData();
      formData.append("buyerName", values.buyerName);
      formData.append("buyerEmail", values.buyerEmail);
      formData.append("buyerContact", values.buyerContact);
      formData.append("buyerAddress", values.buyerAddress);
      formData.append("buyerPanCardId", values.buyerPanCardId);
      formData.append("buyerAadharCardId", values.buyerAadharCardId);
      formData.append(
        "buyerAddressProofTypeOfDocument",
        values.buyerAddressProofTypeOfDocument
      );
      formData.append("buyerPanCardFile", values.buyerPanCardFile);
      formData.append("buyerAadharCardFile", values.buyerAadharCardFile);
      formData.append("buyerAddressProofFile", values.buyerAddressProofFile);
      formData.append("carId", values.carId);
      setLoader(true);
      initiateTransaction(formData)
        .unwrap()
        .then((res) => {
          alert("Transaction Initiated");
          setLoader(false);
          navigate(`/transaction-process?id=${res?.transaction?._id}`);
        })
        .catch((err) => {
          setLoader(false);
          alert("Transaction Failed");
        });
    },
  });

  useEffect(() => {
    if (!customer) return;
    formik.setFieldValue("buyerName", customer?.customerName || "");
    formik.setFieldValue("buyerEmail", customer?.customerEmail || "");
    formik.setFieldValue("buyerContact", customer?.customerNumber || "");
    formik.setFieldValue("buyerAddress", customer?.customerAddress || "");
    formik.setFieldValue("buyerPanCardId", "");
    formik.setFieldValue("buyerAadharCardId", "");
    formik.setFieldValue("buyerAddressProofTypeOfDocument", "");
    formik.setFieldValue("buyerPanCardFile", null);
    formik.setFieldValue("buyerAadharCardFile", null);
    formik.setFieldValue("buyerAddressProofFile", null);
  }, [customer]);

  if (!customer) return null;

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <div className="grid grid-cols-2 gap-4">
          <TextField
            id="buyerName"
            label="Customer Name"
            type="text"
            fullWidth
            value={formik.values.buyerName}
            onChange={formik.handleChange}
            error={formik.touched.buyerName && Boolean(formik.errors.buyerName)}
            helperText={formik.touched.buyerName && formik.errors.buyerName}
          />
          <TextField
            id="buyerEmail"
            label="Customer Email"
            type="text"
            fullWidth
            value={formik.values.buyerEmail}
            onChange={formik.handleChange}
            error={
              formik.touched.buyerEmail && Boolean(formik.errors.buyerEmail)
            }
            helperText={formik.touched.buyerEmail && formik.errors.buyerEmail}
          />
          <TextField
            id="buyerContact"
            label="Customer Contact"
            type="text"
            fullWidth
            value={formik.values.buyerContact}
            onChange={formik.handleChange}
            error={
              formik.touched.buyerContact && Boolean(formik.errors.buyerContact)
            }
            helperText={
              formik.touched.buyerContact && formik.errors.buyerContact
            }
          />
          <TextField
            id="buyerAddress"
            label="Customer Address"
            type="text"
            fullWidth
            value={formik.values.buyerAddress}
            onChange={formik.handleChange}
            error={
              formik.touched.buyerAddress && Boolean(formik.errors.buyerAddress)
            }
            helperText={
              formik.touched.buyerAddress && formik.errors.buyerAddress
            }
          />
          <TextField
            id="buyerPanCardId"
            label="Customer Pan Card Number"
            type="text"
            fullWidth
            value={formik.values.buyerPanCardId}
            onChange={formik.handleChange}
            error={
              formik.touched.buyerPanCardId &&
              Boolean(formik.errors.buyerPanCardId)
            }
            helperText={
              formik.touched.buyerPanCardId && formik.errors.buyerPanCardId
            }
          />
          <TextField
            id="buyerAadharCardId"
            label="Customer Aadhaar Card Number"
            type="text"
            fullWidth
            value={formik.values.buyerAadharCardId}
            onChange={formik.handleChange}
            error={
              formik.touched.buyerAadharCardId &&
              Boolean(formik.errors.buyerAadharCardId)
            }
            helperText={
              formik.touched.buyerAadharCardId &&
              formik.errors.buyerAadharCardId
            }
          />
          <TextField
            id="buyerAddressProofTypeOfDocument"
            label="Customer Address Proof Document Type"
            type="text"
            fullWidth
            value={formik.values.buyerAddressProofTypeOfDocument}
            onChange={formik.handleChange}
            error={
              formik.touched.buyerAddressProofTypeOfDocument &&
              Boolean(formik.errors.buyerAddressProofTypeOfDocument)
            }
            helperText={
              formik.touched.buyerAddressProofTypeOfDocument &&
              formik.errors.buyerAddressProofTypeOfDocument
            }
          />
          <MuiFileInput
            id="buyerPanCardFile"
            label="Customer Pan Card File"
            fullWidth
            value={formik.values.buyerPanCardFile}
            onChange={(value) => {
              formik.setFieldValue("buyerPanCardFile", value);
            }}
            helperText={
              formik.touched.buyerPanCardFile && formik.errors.buyerPanCardFile
            }
            error={
              formik.touched.buyerPanCardFile &&
              Boolean(formik.errors.buyerPanCardFile)
            }
          />
          <MuiFileInput
            id="buyerAadharCardFile"
            label="Customer Aadhaar Card File"
            type="file"
            fullWidth
            value={formik.values.buyerAadharCardFile}
            onChange={(value) => {
              formik.setFieldValue("buyerAadharCardFile", value);
            }}
            helperText={
              formik.touched.buyerAadharCardFile &&
              formik.errors.buyerAadharCardFile
            }
            error={
              formik.touched.buyerAadharCardFile &&
              Boolean(formik.errors.buyerAadharCardFile)
            }
          />
          <MuiFileInput
            id="buyerAddressProofFile"
            label="Customer Address Proof File"
            type="file"
            fullWidth
            value={formik.values.buyerAddressProofFile}
            onChange={(value) => {
              formik.setFieldValue("buyerAddressProofFile", value);
            }}
            helperText={
              formik.touched.buyerAddressProofFile &&
              formik.errors.buyerAddressProofFile
            }
            error={
              formik.touched.buyerAddressProofFile &&
              Boolean(formik.errors.buyerAddressProofFile)
            }
          />
        </div>
        <Button
          className="my-2 bg-slate-600 hover:bg-slate-700"
          type="submit"
          variant="contained"
        >
          Inititate
        </Button>
      </form>
    </>
  );
};

export default EditCustomer;
